import { render, staticRenderFns } from "./PgSelection.vue?vue&type=template&id=60af5b06&scoped=true&"
import script from "./PgSelection.vue?vue&type=script&lang=js&"
export * from "./PgSelection.vue?vue&type=script&lang=js&"
import style0 from "./PgSelection.vue?vue&type=style&index=0&id=60af5b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60af5b06",
  null
  
)

export default component.exports